import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SetupLayout from "../SetupLayout/SetupLayout";
import { useSetupState, useSetupDispatch, setCompany, resetSetup } from "../../../auth/SetupContext";
import { API_BASE_URL } from "../../../auth/config";
import formStyles from "../setupForm.module.scss";

export default function GrantAccess() {
  const navigate = useNavigate();
  const dispatch = useSetupDispatch();
  const { companyId, clientId, userId } = useSetupState();

  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!companyId) navigate("/setup/company", { replace: true });
  }, [companyId, navigate]);

  const handleGrant = async () => {
    setError("");
    setIsSubmitting(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/companies/add-client?companyId=${companyId}&clientId=${clientId}`
      );
      dispatch(setCompany(res.data));
      navigate(userId ? "/setup/user-access" : "/setup/roles", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to grant company access");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBack = () => {
    navigate("/", { replace: true });
    setTimeout(() => dispatch(resetSetup()), 0);
  };

  return (
    <SetupLayout
      step={3}
      totalSteps={6}
      title="Grant client access"
      subtitle="Allow this OAuth client to access the company."
      error={error}
      onBack={handleBack}
      backDisabled={isSubmitting}
      loading={isSubmitting}
      loadingText="Granting access..."
    >
      <div className={formStyles.fieldGroup}>
        <label className={formStyles.label}>Company</label>
        <div className={formStyles.readOnlyValue}>{companyId}</div>
      </div>
      <div className={formStyles.btnRow}>
        <button type="button" className={formStyles.primaryBtn} onClick={handleGrant} disabled={isSubmitting}>
          {isSubmitting ? "Granting..." : "Grant access"}
        </button>
      </div>
    </SetupLayout>
  );
}
